import styled from '@emotion/styled';
import Link from 'next/link';

import { TagWrap, Title } from './styled';
import BlogRelated from './BlogRelated';
import { breakPoints } from 'constant/breakPoints';
import { useRef } from 'react';
import { Blog, TBlogDetail } from 'constant/type';
import { FormatDate } from 'components/_common/FormatDate';

export default function BlogDetail({
  blog,
  relatedBlogs,
}: {
  blog: TBlogDetail;
  relatedBlogs: Blog[];
}) {
  const refSticky = useRef<HTMLDivElement>(null);
  const refContent = useRef<HTMLDivElement>(null);
  const refThumbnail = useRef<HTMLDivElement>(null);
  // const refIsSticky = useRef(false);

  // Sticky
  // useEffect(() => {
  //   if (!process.browser) return;

  //   // Create the observer, same as before:
  //   const observer = new IntersectionObserver((entries) => {
  //     entries.forEach((entry) => {
  //       if (!refSticky.current) return;

  //       if (!entry.isIntersecting) {
  //         const rect = refSticky.current.getBoundingClientRect();
  //         refIsSticky.current = true;

  //         refSticky.current.style.left = rect.x + 'px';
  //         refSticky.current.classList.add('sticky');
  //       } else {
  //         refIsSticky.current = false;
  //         refSticky.current.classList.remove('sticky');
  //       }
  //     });
  //   });

  //   refThumbnail.current && observer.observe(refThumbnail.current);

  //   return () => {
  //     observer.disconnect();
  //   };
  // }, []);

  // Limit  sticky
  // useEffect(() => {
  //   if (!process.browser) return;

  //   // Create the observer, same as before:
  //   const observer = new IntersectionObserver((entries) => {
  //     entries.forEach((entry) => {
  //       if (!refContent.current || !refSticky.current || !refIsSticky.current)
  //         return;

  //       if (!entry.isIntersecting) {
  //         const rect = refContent.current.getBoundingClientRect();

  //         refSticky.current.style.top = rect.height + 'px';
  //         refSticky.current.classList.remove('sticky');
  //         refSticky.current.classList.add('sticky-limit');
  //       } else {
  //         refSticky.current.style.top = '0';
  //         refSticky.current.classList.add('sticky');
  //         refSticky.current.classList.remove('sticky-limit');
  //       }
  //     });
  //   });

  //   refContent.current && observer.observe(refContent.current);

  //   return () => {
  //     observer.disconnect();
  //   };
  // }, []);

  return (
    <Wrap>
      <Thumbnail ref={refThumbnail}>
        <div>
          <img src={blog.image?.url} alt="Spirit labs" />
        </div>
      </Thumbnail>

      <WrapFlex>
        <WrapContent ref={refContent}>
          <Title>
            <div>{FormatDate(blog.published)}</div>
            <h1>{blog.heading}</h1>
          </Title>
          <TagWrap>
            {blog.categories.map((item, idx) => (
              <li key={idx}>{'#' + item.title}</li>
            ))}
          </TagWrap>
          <Content dangerouslySetInnerHTML={{ __html: blog.content }} />
        </WrapContent>
        <WrapSignUp>
          <SignUpContainer ref={refSticky}>
            <Publisher>
              <img src="/images/icon/pencil.svg" alt="edit-icon" />
              <span>Editor:</span>
              <strong>{blog.author?.name}</strong>
            </Publisher>
            <ShareWrap>
              <Link href="https://www.facebook.com/spiritlabs.co">
                <a>
                  <img
                    src="/images/icon/fb.svg"
                    alt="spiritlabs-facebook-icon"
                  />
                </a>
              </Link>
              <Link href="https://www.linkedin.com/company/spirit-labs">
                <a>
                  <img
                    src="/images/icon/ln.svg"
                    alt="spiritlabs-linkedin-icon"
                  />
                </a>
              </Link>
              <Link href="https://twitter.com/spiritlabs_vn">
                <a>
                  <img
                    src="/images/icon/twitter.svg"
                    alt="spiritlabs-twitter-icon"
                  />
                </a>
              </Link>
            </ShareWrap>
            {/* <div>
              <div className="title2">Sign up for our Newsletter</div>
              <div className="type1 text-gray2">
                Stay tuned for useful contents and industry insights with our
                monthly newsletters
              </div>
              <input placeholder="Please enter your email" />
              <button>Subscribe</button>
            </div> */}
            <BlogRelated relatedBlogs={relatedBlogs} />
          </SignUpContainer>
        </WrapSignUp>
      </WrapFlex>

      {/* <BlogRelated relatedBlogs={relatedBlogs} /> */}
    </Wrap>
  );
}

const Wrap = styled.div`
  padding-top: 90px;
  max-width: 1140px;
  margin: 0 auto;

  ${Title} {
    h1 {
      font-size: 24px;
      line-height: 130%;
    }
  }

  @media screen and (min-width: ${breakPoints.desktopS}px) {
    display: flex;
    flex-wrap: wrap;
    padding-top: 114px;
    padding-left: 16px;
    padding-right: 16px;
  }
`;

const Thumbnail = styled.div`
  width: calc(100% + 32px);
  margin-left: -16px;
  margin-bottom: 32px;
  overflow: hidden;

  div {
    width: 100%;
    height: 100%;
    background-color: #f6e8fd;
    transition: all 0.2s ease;
    padding-top: 56.25%;
    position: relative;

    img {
      position: absolute;
      top: 0;
      left: 0;
      object-fit: cover;
      height: 100%;
      width: 100%;
    }
  }

  @media screen and (min-width: ${breakPoints.desktopS}px) {
    margin-left: 0;
  }
`;

const WrapFlex = styled.div`
  display: flex;
  flex-wrap: wrap;
  position: relative;
  width: 100%;
`;

const WrapContent = styled.div`
  padding: 0 16px;

  @media screen and (min-width: ${breakPoints.desktopS}px) {
    min-width: 580px;
    max-width: 838px;
    padding: 0 56px 0 0;
    flex: 1;
    margin-bottom: 80px;

    ${Title} {
      & > div:first-of-type {
        font-size: 14px;
      }

      & > h1 {
        font-size: 42px;

        &:hover {
          color: inherit;
        }
      }
    }
  }
`;

const Content = styled.div`
  font-size: 16px;
  line-height: 140%;
  letter-spacing: 0.005em;
  margin: 32px 0 0;
  color: #444052;

  .image {
    max-width: 100%;
    margin-left: 0;

    img {
      max-width: 100%;
    }
  }

  div:first-of-type {
    position: relative;
    max-width: 100%;

    .g-ordered-list {
      padding-left: 70px;
      color: #444052;

      &::before {
        content: 'Table of Contents';
        display: block;
        font-size: 24px;
        font-weight: 600;
        margin-bottom: 20px;
        margin-left: -70px;
        color: #444052;
      }
      ::after {
        content: '';
        position: absolute;
        top: 42px;
        left: 16px;
        width: 4px;
        height: calc(100% - 42px);
        background-color: #e8e8ea;
      }

      & ol {
        list-style-type: none;
        counter-reset: item;
      }

      li {
        display: block;
        position: relative;
        font-size: 16px;
        font-weight: 500;
        display: table;
        counter-increment: item;

        &::before {
          content: counters(item, '.') '. ';
          display: table-cell;
          position: absolute;
          margin-right: 100%;
          right: 10px;
        }

        .child-list {
          padding-left: 30px;

          li {
            font-size: 14px;
            font-weight: 400;
            color: #73707d;

            &::before {
              content: counters(item, '.') '. ';
            }
          }
        }
      }
    }
  }

  h2 {
    line-height: 130%;
    color: var(--purple-branding);
  }

  @media screen and (min-width: ${breakPoints.desktopS}px) {
    border-bottom: 1px solid #e8e8ea;
    padding-bottom: 90px;
  }
`;

const Publisher = styled.div`
  display: flex;

  img {
    margin-right: 8px;
  }

  span {
    margin-right: 5px;
    color: #73707d;
  }

  strong {
    font-size: 16px;
    font-weight: 500;
  }
`;

const ShareWrap = styled.div`
  display: flex;
  margin-top: 24px;
  margin-bottom: 32px;

  & > * {
    margin-right: 24px;
  }
`;

const SignUpContainer = styled.div`
  & > div {
    padding: 0 16px;
  }

  & > div:last-of-type {
    border-top: 8px solid #e8e8ea;
    padding: 32px 16px 0;

    input {
      padding: 16px 8px;
      background: #f2f2f5;
      border: none;
      outline: 0;
      font-size: 14px;
      border-bottom: 3px solid #e8e8ea;
      margin: 24px 0 32px;
      width: 100%;
    }

    button {
      background: linear-gradient(
        188.34deg,
        #a336d9 13.45%,
        rgba(163, 54, 217, 0.6) 144.25%
      );
      border-radius: 100px;
      display: block;
      text-align: center;
      cursor: pointer;
      padding: 10px 30px;
      transition: 0.4s ease-in-out;
      border: 2px solid transparent;
      color: #fff;
      margin: 0 auto;
      font-size: 16px;

      &:hover {
        border-color: #a336d9;
        background: transparent;
        color: #a336d9;
      }
    }
  }

  @media screen and (min-width: ${breakPoints.desktopS}px) {
    &.sticky {
      position: fixed;
      top: 0;
      padding-top: 32px;
      max-width: 270px;
    }

    &.sticky-limit {
      position: absolute;
      max-width: 270px;
      padding-top: 32px;
      left: initial !important;
      right: 0;
    }

    & > div {
      padding: 0;
    }

    & > div:last-of-type {
      padding: 8px 0 0;
      border-top: none;

      .title2 {
        font-size: 24px;
        margin-bottom: 8px;
      }

      button {
        padding: 15px 36px;
      }
    }
  }
`;

const WrapSignUp = styled.div`
  padding: 32px 0;
  height: min-content;
  flex-basis: 100%;

  @media screen and (min-width: ${breakPoints.desktopS}px) {
    flex: 0 0 270px;
    padding-top: 0;
    position: sticky;
    top: -100px;
  }
`;
